import React from "react";
import NextImage from "../NextImage";
import ShirtIcon from "./ShirtIcon";
import { linkName } from "../../../utils/generalLiveCenter";

const GOAL_TYPE_ICONS = {
  Goal: "football-outline",
  Penalty: "penalty",
  "Disallowed goal": "var",
  default: "ongoal",
};

const PlayerIcon = ({ src, alt, count, className }) => (
  <span className={className}>
    <NextImage src={src} width={12} height={12} alt={alt} />
    {count > 1 ? <span className="count-num">{count}</span> : null}
  </span>
);

const PlayerCard = ({ player, sno, kitColor, baseURL, sport }) => {
  const {
    football_goals = [],
    cards = [],
    substitutions_out,
    assist = [],
    nm: playerName,
    id: playerId,
  } = player || {};

  const goalsCount = football_goals?.length;
  const goalType = football_goals?.[0]?.ty;
  const goalIcon = GOAL_TYPE_ICONS[goalType] || GOAL_TYPE_ICONS.default;

  const cardsCount = cards?.length;
  const cardType = cards?.[0]?.ty;
  const cardIcon =
    cardsCount > 1
      ? "card-yellowred"
      : cardType?.includes("Yellow")
      ? "card-yellow"
      : "card-red";

  const hasAssist = assist?.length > 0;

  return (
    <div className="shirt_wrap">
      <a href={`/${sport}/player/${linkName(playerName)}/${playerId}/info`}>
        <div className="img_wrap">
          <ShirtIcon kitColor={kitColor} />
          <strong className="shirt_num">{sno}</strong>

          {goalsCount > 0 ? (
            <PlayerIcon
              src={`${baseURL}/public/assets/images/svg/${goalIcon}.svg`}
              alt="goal"
              count={goalsCount}
              className="football_icon"
            />
          ) : null}

          {hasAssist ? (
            <PlayerIcon
              src={`${baseURL}/public/assets/images/svg/free-kick.svg`}
              alt="assist"
              className="downLeft_icon"
            />
          ) : null}

          {cardsCount > 0 ? (
            <PlayerIcon
              src={`${baseURL}/public/assets/images/svg/${cardIcon}.svg`}
              alt="card"
              className="card_icon"
            />
          ) : null}

          {substitutions_out ? (
            <PlayerIcon
              src={`${baseURL}/public/assets/images/svg/down-arrow.svg`}
              alt="substitution"
              className="down_icon"
            />
          ) : null}
        </div>
        <span className="player_name">
          <span className="pyr_nm_in">{playerName}</span>
        </span>
      </a>
    </div>
  );
};

const LineupRow = ({ Team, kitColor, sport = "football" }) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  return (
    <>
      {Team?.map((row, rowIndex) => (
        <div key={rowIndex} className="player-row">
          {row?.map(({ sno, player }) => (
            <PlayerCard
              key={sno}
              player={player}
              sno={sno}
              kitColor={kitColor}
              baseURL={baseURL}
              sport={sport}
            />
          ))}
        </div>
      ))}
    </>
  );
};

export default LineupRow;
